export default "__VITE_ASSET__nQmWDWLr__"